import React from "react";

const Submit = ({ onClick, children }) => (
  <button className="LoginSubmit button primary large" onClick={onClick}>
    {children}
  </button>
);

export default Submit;
